import React from "react";
import H2 from "../../components/elements/titles/H2";
import Paragraph from "../../components/elements/p/Paragraph";

const BodyLocation = () => {
  return (
    <section className="marginNavbar">
      <div className=" mt-32 px-4 text-center md:mt-48">
        <H2>Nti / Localisation</H2>
        <Paragraph classe="mt-2">
          Nos locaux sont situés à la chapelle obili tout prêt de la seconde
          entrée de l'université de Yaoundé 1
        </Paragraph>
      </div>
      <section className="mx-auto mt-10 h-[500Px] max-w-7xl">
        <iframe
          title="nti-localisation"
          style={{ width: "100%", height: "100%" }}
          src="https://maps.google.com/maps?q=chapelle%20obili&t=&z=13&ie=UTF8&iwloc=&output=embed"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        ></iframe>
      </section>
    </section>
  );
};

export default BodyLocation;
